import { Provider } from '@angular/core'
import { environment } from '../../environments/environment'
import { environmentNameToken } from 'shared-components'

export const playEnvironmentNameProvider: Provider[] = [
  {
    provide: environmentNameToken,
    useValue: environment.name,
  },
]
